import {useGlobalLoadingControl} from "../../loading/use-loading-control.tsx"
import {Box, LinearProgress} from "@mui/material"

export default function StickyLinearProgress() {

    const isLoading = useGlobalLoadingControl()

    return (
        <>
            { isLoading &&
                <Box
                    sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        backgroundColor: 'background.paper',
                    }}
                >
                    {<LinearProgress/>}
                </Box>
            }
        </>
    )
}